<h1 mat-dialog-title>Plantillas</h1>
<div class="table-scroll">
  <mat-spinner *ngIf="loading"></mat-spinner>
  <table mat-table class="full-width"  *ngIf="!loading" [dataSource]="studyReportTemplateFiltersDataSource">
    <tr mat-header-row class="table-header" *matHeaderRowDef="studyReportTemplateFiltersColums"></tr>
    <tr mat-row class="table-cell" *matRowDef="let row; let i = index; columns: studyReportTemplateFiltersColums;"></tr>

    <ng-container matColumnDef="Select">
      <th mat-header-cell class="table-header" *matHeaderCellDef> </th>
      <td mat-cell class="table-cell" *matCellDef="let element">
        <mat-checkbox (change)="checkChange(element.Id)"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="Name">
      <th mat-header-cell class="table-header" *matHeaderCellDef> Nombre </th>
      <td mat-cell class="table-cell" *matCellDef="let element">
        {{element.Name}}
      </td>
    </ng-container>
 
  </table>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button  (click)="save()">Aceptar</button>
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
  </div>
</div>
